// frontend/packages/business-console/src/components/primitives/Surface.jsx
//
// The console's base card surface: token-driven background, 1px border,
// rounded corner. Every panel, table container, and stat card sits on
// one of these so borders/radii/backgrounds never drift between pages.
//
// Named `Surface` (not `Card`) to avoid colliding with MUI's `Card`.
// Forwards a ref and accepts `component` so it can be a clickable
// RouterLink row (`component={RouterLink} to={...} interactive`).

import React, { forwardRef } from 'react';
import { Box } from '@mui/material';

import { useTokens } from './useTokens';

const Surface = forwardRef(function Surface(
  { children, radius = '14px', interactive = false, sx, ...rest },
  ref
) {
  const t = useTokens();
  return (
    <Box
      ref={ref}
      sx={{
        bgcolor: t.card,
        border: `1px solid ${t.cardBorder}`,
        borderRadius: radius,
        minWidth: 0,
        ...(interactive
          ? {
              cursor: 'pointer',
              transition: 'background-color .12s ease',
              '&:hover': { bgcolor: t.subtle },
            }
          : null),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
});

export default Surface;
